import { IconBack } from '@adc/parallax-component-library';

export const TopHeaderBackArrow = ({ testID }: { testID?: string }) => (
  <IconBack color="$neutral.100" testID={testID} />
);
